import { useState } from 'react';
import { useSelector } from 'react-redux';
import useLocalize from '../../utils/hooks/useLocalize';
import ScanCard from './ScanCard/ScanCard';

const SavedPresetScansSection = () => {
  const [activeTab, setActiveTab] = useState('preset');
  const localize = useLocalize();

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const userScans = useSelector((state) => state.scans.userScans || []);
  const isLoading = useSelector((state) => state.scans.isLoading || false);

  const handleScanDetailsClick = () => {
    // TODO: Open the details popup with a follow up story
  };

  const handleScanActionsMenuClick = () => {
    // TODO: Open the actions menu with a follow up story
  };

  const renderMyScansContent = () => {
    if (isLoading) {
      return localize('desktop.scans.myscans.construction');
    }

    if (!userScans || userScans.length === 0) {
      return localize('desktop.scans.myscans.empty');
    }

    return (
      <div className="scan-cards-container">
        {userScans.map((scan) => (
          <ScanCard
            key={scan.id}
            scan={scan}
            onDetailsClick={handleScanDetailsClick}
            onActionsMenuClick={handleScanActionsMenuClick}
          />
        ))}
      </div>
    );
  };

  const renderTabContent = () => {
    if (activeTab === 'myscans') {
      return (
        <div className="saved-preset-tab-content">
          <div className="placeholder-text">{renderMyScansContent()}</div>
        </div>
      );
    }

    return (
      <div className="saved-preset-tab-content">
        <div className="placeholder-text">
          {localize('desktop.scans.recommended.construction')}
        </div>
      </div>
    );
  };

  return (
    <div className="saved-preset-scans-section">
      <div className="saved-preset-tabs">
        <div className="saved-preset-tabs-header">
          <button
            className={`saved-preset-tab ${
              activeTab === 'preset' ? 'active' : ''
            }`}
            onClick={() => handleTabChange('preset')}
          >
            {localize('desktop.scans.tab.recommended')}
          </button>
          <button
            className={`saved-preset-tab ${
              activeTab === 'myscans' ? 'active' : ''
            }`}
            onClick={() => handleTabChange('myscans')}
          >
            {localize('desktop.scans.tab.myscans')}
          </button>
        </div>
        {renderTabContent()}
      </div>
    </div>
  );
};

export default SavedPresetScansSection;
